(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9559],{

/***/ 3961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var spec_1 = __webpack_require__(18293);
/**
 * file size
 * @param bytes
 * @param fixed
 * @param spec
 */
function default_1(bytes, fixed, spec) {
    if (fixed === void 0) { fixed = 1; }
    bytes = Math.abs(bytes);
    var _a = spec_1.SPECS[spec] || spec_1.SPECS['jedec'], radix = _a.radix, unit = _a.unit;
    var loop = 0;
    // calculate
    while (bytes >= radix) {
        bytes /= radix;
        ++loop;
    }
    return bytes.toFixed(fixed) + " " + unit[loop];
}
exports.Z = default_1;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 18293:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var si = { radix: 1e3, unit: ['b', 'kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'] };
var iec = { radix: 1024, unit: ['b', 'Kib', 'Mib', 'Gib', 'Tib', 'Pib', 'Eib', 'Zib', 'Yib'] };
var jedec = { radix: 1024, unit: ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'] };
exports.SPECS = {
    si: si,
    iec: iec,
    jedec: jedec,
};
//# sourceMappingURL=spec.js.map

/***/ }),

/***/ 90161:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-complaints",
      function () {
        return __webpack_require__(8511);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_customer_complaints; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/meta/index.tsx + 2 modules
var meta = __webpack_require__(59409);
// EXTERNAL MODULE: ./src/gql/mutations/index.ts + 42 modules
var mutations = __webpack_require__(36651);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/hooks/index.ts + 30 modules
var hooks = __webpack_require__(91497);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/utils/form-validators.ts + 1 modules
var form_validators = __webpack_require__(99432);
// EXTERNAL MODULE: ./src/utils/handle-submission-errors.ts
var handle_submission_errors = __webpack_require__(79459);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
;// CONCATENATED MODULE: ./src/screens/customer-complaints/elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  max-width: unset;\n  min-height: 100vh;\n  padding: ",
        "px;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa00cbfb-0"
})(_templateObject(), theme/* default.colors.white */.Z.colors.white, theme/* default.spacing.cozy */.Z.spacing.cozy * 4, theme/* default.spacing.relaxed */.Z.spacing.relaxed, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 120);

// EXTERNAL MODULE: ./node_modules/react-recaptcha/dist/react-recaptcha.js
var react_recaptcha = __webpack_require__(95920);
var react_recaptcha_default = /*#__PURE__*/__webpack_require__.n(react_recaptcha);
// EXTERNAL MODULE: ./node_modules/filesize.js/lib/index.js
var lib = __webpack_require__(3961);
// EXTERNAL MODULE: ./src/components/index.ts + 136 modules
var components = __webpack_require__(13823);
// EXTERNAL MODULE: ./src/components/datepicker/index.js + 1 modules
var datepicker = __webpack_require__(61845);
// EXTERNAL MODULE: ./src/components/input-file/index.tsx + 2 modules
var input_file = __webpack_require__(76741);
// EXTERNAL MODULE: ./src/hooks/use-coverage.ts
var use_coverage = __webpack_require__(13624);
// EXTERNAL MODULE: ./src/hooks/use-formatters.ts
var use_formatters = __webpack_require__(13405);
// EXTERNAL MODULE: ./src/truck/anchor/index.ts
var truck_anchor = __webpack_require__(75689);
// EXTERNAL MODULE: ./src/truck/field/index.tsx + 2 modules
var field = __webpack_require__(49318);
// EXTERNAL MODULE: ./src/truck/new-button/NewButton.tsx + 4 modules
var NewButton = __webpack_require__(8262);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
;// CONCATENATED MODULE: ./src/screens/customer-complaints/form/attached-file-preview.tsx

function attached_file_preview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border: 1px dashed ",
        ";\n  display: flex;\n  flex-direction: row;\n  height: ",
        "px;\n  margin: ",
        "px 0;\n  padding: ",
        "px;\n  width: 50%;\n\n  ",
        " {\n    min-width: 100%;\n  }\n\n  > svg {\n    height: 11.64px;\n    width: 11.64px;\n  }\n"
    ]);
    attached_file_preview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledPreviewContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8590f89-0"
})(attached_file_preview_templateObject(), function(props) {
    return props.theme.palette.grayscale30;
}, function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.theme.spacing.cozy * 5;
}, function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
}, (0,styled_breakpoints.down)("sm"));
function AttachedFilePreview() {
    var input = (0,react_final_form_es/* useField */.U$)("fileAttachment").input;
    return input.value && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPreviewContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-xs text-tertiary",
                children: input.value.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                color: "grayscale60",
                type: "close",
                onClick: function() {
                    input.onChange(null);
                }
            })
        ]
    });
}
/* harmony default export */ var attached_file_preview = (AttachedFilePreview);

// EXTERNAL MODULE: ./src/truck/grid/index.tsx + 1 modules
var grid = __webpack_require__(25728);
;// CONCATENATED MODULE: ./src/screens/customer-complaints/form/elements.js

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > h3 {\n    margin-bottom: ",
        "px;\n  }\n\n  > h4 {\n    margin: ",
        "px 0;\n  }\n\n  > h4:first-of-type {\n    margin-top: 0;\n  }\n\n  textarea {\n    resize: vertical;\n  }\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n\n  :not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n\n  > ",
        " {\n    max-width: unset;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var elements_Container = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-c9b021-0"
})(elements_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy * 4, theme/* default.spacing.cozy */.Z.spacing.cozy * 4);
var StyledColumn = (0,styled_components_browser_esm/* default */.ZP)(grid/* default.Column */.Z.Column).withConfig({
    componentId: "sc-c9b021-1"
})(_templateObject1(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.marginToRight && "\n      margin-right: ".concat(theme/* default.spacing.comfortable */.Z.spacing.comfortable, "px;\n    ");
});
var StyledGrid = (0,styled_components_browser_esm/* default */.ZP)(grid/* default */.Z).withConfig({
    componentId: "sc-c9b021-2"
})(_templateObject2(), StyledColumn);
StyledGrid.Column = StyledColumn;

;// CONCATENATED MODULE: ./src/screens/customer-complaints/form/index.js






















var complainTexts = {
    claim: "Disconformidad relacionada a los productos o servicios.",
    complaint: "\n    Disconformidad no relacionada a los productos o servicios o malestar o\n    descontento respecto a la atenci\xf3n al p\xfablico. La formulaci\xf3n del reclamo\n    no impide acudir a otras v\xedas de soluci\xf3n de controversias ni es requisito\n    previo para interponer una denuncia ante el INDECOPI.\n  "
};
var GReCaptcha = function(props) {
    var sitekey = props.sitekey, render = props.render, onloadCallback = props.onloadCallback, onChange = props.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_recaptcha_default()), {
        sitekey: sitekey,
        render: render,
        onloadCallback: onloadCallback,
        verifyCallback: function(res) {
            return onChange(res);
        }
    });
};
function AddressFormFields(param) {
    var coverageTree = param.coverageTree;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useLocationSelector */.ld)(coverageTree), 2), divisions = ref[0], onDivisionChange = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,lodash.map)(divisions, function(division, index) {
                var name = division.name, localities = division.localities, fieldName = division.fieldName, fieldValue = division.fieldValue;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                    sm: 12,
                    lg: 6,
                    marginToRight: index % 2 === 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                        label: name,
                        prompt: "Seleccione",
                        as: "select",
                        name: fieldName,
                        value: fieldValue,
                        onChange: function(e) {
                            return onDivisionChange(e.target.value, fieldName);
                        },
                        disabled: (0,lodash.isEmpty)(localities),
                        children: (0,lodash.map)(localities, function(locality) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: locality.id,
                                children: locality.name
                            }, locality.id);
                        })
                    })
                }, name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                sm: 12,
                lg: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                    name: "addressLine",
                    label: "Direcci\xf3n"
                })
            })
        ]
    });
}
var Form = function(props) {
    var ref, ref1;
    var handleSubmit = props.handleSubmit, values = props.values, submitting = props.submitting, style = props.style, className = props.className;
    var claimedAtField = (0,react_final_form_es/* useField */.U$)("claimedAt");
    var ref2 = (0,use_vendor/* default */.Z)(), country = ref2.country, vendorName = ref2.name, privacyPolicyUrl = ref2.privacyPolicyUrl;
    var currencySymbol = country.currencySymbol;
    var ref3 = (0,use_coverage/* default */.Z)(), loadingCoverage = ref3.loading, coverageTree = ref3.coverageTree;
    var ref4 = (0,react.useState)(false), datepickerIsOpen = ref4[0], setDatepickerIsOpen = ref4[1];
    var formatters = (0,use_formatters/* default */.Z)();
    var form = (0,react_final_form_es/* useForm */.cI)();
    var fileSizeHumanFormat = (0,lib/* default */.Z)(constants/* fileSizeLimits.CUSTOMER_COMPLAINT_ATTACHMENT */.M6.CUSTOMER_COMPLAINT_ATTACHMENT, 0);
    var customerComplaintsFF = (0,toggled_esm/* useFeature */.SS)(constants/* flags.CUSTOMER_COMPLAINTS */.id.CUSTOMER_COMPLAINTS);
    var purchaseChannels = customerComplaintsFF === null || customerComplaintsFF === void 0 ? void 0 : (ref = customerComplaintsFF.settings) === null || ref === void 0 ? void 0 : ref.purchaseChannels;
    var ref5;
    var canAttachFile = (ref5 = customerComplaintsFF === null || customerComplaintsFF === void 0 ? void 0 : (ref1 = customerComplaintsFF.settings) === null || ref1 === void 0 ? void 0 : ref1.enableAttachment) !== null && ref5 !== void 0 ? ref5 : false;
    var onDateChange = function(date) {
        claimedAtField.input.onChange(date.toISOString());
        setDatepickerIsOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(elements_Container, {
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-3xl font-bold",
                children: "Libro de Reclamaciones"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xl font-semibold",
                children: "1. Identificaci\xf3n del Consumidor Reclamante"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        marginToRight: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "firstName",
                            label: "Nombres"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "lastName",
                            label: "Apellidos"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        marginToRight: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "email",
                            label: "Correo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "phone",
                            label: "Tel\xe9fono"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        marginToRight: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* TextField */.nv, {
                            name: "documentType",
                            label: "Tipo de documento",
                            as: "select",
                            prompt: "Seleccione",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "dni",
                                    children: "DNI"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "ce",
                                    children: "CE"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "documentNumber",
                            label: "N\xfamero de documento"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            name: "isUnderage",
                            as: "checkbox",
                            children: "\xbfEs menor de edad?"
                        })
                    }),
                    values.isUnderage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                marginToRight: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                    name: "parentFirstName",
                                    label: "Nombres del apoderado",
                                    disabled: !values.isUnderage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                    name: "parentLastName",
                                    label: "Apellidos del apoderado",
                                    disabled: !values.isUnderage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                marginToRight: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                    name: "parentEmail",
                                    label: "Correo del apoderado",
                                    disabled: !values.isUnderage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                    name: "parentPhone",
                                    label: "Tel\xe9fono del apoderado",
                                    disabled: !values.isUnderage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                marginToRight: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* TextField */.nv, {
                                    name: "parentDocumentType",
                                    label: "Tipo de documento del apoderado",
                                    as: "select",
                                    prompt: "Seleccione",
                                    disabled: !values.isUnderage,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "dni",
                                            children: "DNI"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "ce",
                                            children: "CE"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                                sm: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                    name: "parentDocumentNumber",
                                    label: "N\xfamero de documento del apoderado",
                                    disabled: !values.isUnderage
                                })
                            })
                        ]
                    }),
                    !loadingCoverage && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressFormFields, {
                        coverageTree: coverageTree
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xl font-semibold",
                children: "2. Identificaci\xf3n del Bien Contratado"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 6,
                        lg: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            as: "radio",
                            name: "assetType",
                            value: "product",
                            id: "p-radio",
                            children: "Producto"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 6,
                        lg: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            as: "radio",
                            name: "assetType",
                            value: "service",
                            id: "s-radio",
                            children: "Servicio"
                        })
                    }),
                    purchaseChannels && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        marginToRight: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "purchaseChannel",
                            label: "Medio de compra",
                            as: "select",
                            prompt: "Seleccione",
                            children: (0,lodash.map)(purchaseChannels, function(purchaseChannel) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: purchaseChannel,
                                    children: purchaseChannel
                                }, purchaseChannel);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        marginToRight: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            readOnly: true,
                            name: "claimedAt",
                            label: "Fecha",
                            format: formatters.date,
                            autoComplete: "off",
                            onFocus: function() {
                                return setDatepickerIsOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        lg: 6,
                        style: {
                            flexGrow: purchaseChannels ? 0 : 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "claimedAmount",
                            label: "Monto reclamado",
                            placeholder: "00.00",
                            renderAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: currencySymbol
                            }),
                            type: "number"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            as: "textarea",
                            name: "assetDescription",
                            label: "Descripci\xf3n"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "text-xl font-semibold",
                children: "3. Detalle de la Reclamaci\xf3n y Pedido del Consumidor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 6,
                        lg: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            as: "radio",
                            name: "complainType",
                            value: "claim",
                            id: "c-radio",
                            children: "Reclamo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 6,
                        lg: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            as: "radio",
                            name: "complainType",
                            value: "complaint",
                            id: "r-radio",
                            children: "Queja"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                borderRadius: 4,
                                padding: 16,
                                display: "flex",
                                backgroundColor: theme/* default.colors.grayLight */.Z.colors.grayLight
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: complainTexts[values.complainType]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            as: "textarea",
                            name: "details",
                            label: "Detalle"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            as: "textarea",
                            name: "customerRequest",
                            label: "Pedido del reclamante"
                        })
                    }),
                    canAttachFile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrid.Column, {
                        sm: 6,
                        lg: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_file/* InputFile */.h, {
                                sizeLimit: constants/* fileSizeLimits.CUSTOMER_COMPLAINT_ATTACHMENT */.M6.CUSTOMER_COMPLAINT_ATTACHMENT,
                                accept: constants/* allowedFileExtensions.CUSTOMER_COMPLAINT_ATTACHMENT */.t.CUSTOMER_COMPLAINT_ATTACHMENT,
                                onChange: function(e) {
                                    form.change("fileAttachment", e.target.files[0]);
                                },
                                style: {
                                    maxWidth: "50%"
                                },
                                description: "JPG, PNG o PDF tama\xf1o m\xe1x. de ".concat(fileSizeHumanFormat)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(attached_file_preview, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                            as: "checkbox",
                            name: "termsAccepted",
                            children: "Me encuentro conforme con los t\xe9rminos de mi reclamo o queja"
                        })
                    }),
                    privacyPolicyUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(field/* default */.Z, {
                            as: "checkbox",
                            name: "privacyPolicyAccepted",
                            children: [
                                "Declaro que he le\xeddo y acepto la ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_anchor/* default */.Z, {
                                    href: "/politica-de-privacidad",
                                    target: "_blank",
                                    $color: "info",
                                    children: "Pol\xedtica de Privacidad"
                                }),
                                " de ".concat(vendorName)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid.Column, {
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-8 mt-4",
                            children: "El proveedor deber\xe1 dar respuesta al reclamo en un plazo no mayor de quince (15) d\xedas h\xe1biles."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
                name: "reCaptchaToken",
                component: GReCaptcha,
                style: {
                    marginBottom: theme/* default.spacing.cozy */.Z.spacing.cozy * 8
                },
                sitekey: "6LcatKwUAAAAAMVEBJ0k_ECm4ffy4LrWoVOc098k",
                render: "explicit",
                onloadCallback: function() {
                    return null;
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                type: "button",
                onClick: handleSubmit,
                loading: submitting,
                children: "Enviar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(datepicker/* default */.Z, {
                isOpen: datepickerIsOpen,
                onClose: function() {
                    return setDatepickerIsOpen(false);
                },
                value: claimedAtField.input.value,
                onChange: onDateChange
            })
        ]
    });
};
/* harmony default export */ var customer_complaints_form = (Form);

// EXTERNAL MODULE: ./src/components/logo/index.js + 1 modules
var logo = __webpack_require__(2372);
// EXTERNAL MODULE: ./src/components/media/index.ts
var media = __webpack_require__(43902);
;// CONCATENATED MODULE: ./src/screens/customer-complaints/header/index.tsx





function Header() {
    var vendor = (0,hooks/* useVendor */.at)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "text-xl font-bold",
                        children: vendor.fiscalName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: vendor.ruc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: vendor.fiscalAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Tienda Online: las ventas online no aplican a menores de 18 a\xf1os"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* default */.Z, {
                desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                    className: "ml-auto",
                    alternative: true,
                    vendor: vendor,
                    size: "large"
                }),
                mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                    className: "ml-auto",
                    alternative: true,
                    vendor: vendor,
                    size: "small"
                })
            })
        ]
    });
}
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/screens/customer-complaints/success-state/index.tsx






function SuccessState(param) {
    var style = param.style, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("flex flex-col items-center", className),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-center text-3xl font-bold",
                children: [
                    "Gracias por tu comunicaci\xf3n",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xl font-normal",
                        children: "hemos recibido tus datos"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative my-8 flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        className: "absolute right-0 top-0 -translate-y-1/2 translate-x-1/2",
                        type: "check",
                        color: "success",
                        size: "xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        className: "size-32",
                        type: "document",
                        color: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                    asChild: true,
                    className: "w-44",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: "Continuar"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var success_state = (SuccessState);

;// CONCATENATED MODULE: ./src/screens/customer-complaints/index.tsx
























moment_timezone_default().locale("es");
var now = moment_timezone_default()();
var formattedNow = "".concat((0,lodash.capitalize)(now.format("dddd")), ", ").concat(now.format("LL"));
var initialValues = {
    assetType: "product",
    complainType: "claim",
    isUnderage: false
};
var CustomerComplaintsScreen = function(props) {
    var ref;
    var code = props.code;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)(mutations/* createCustomerComplaintMutation */.vS), 1), createCustomerComplaint = ref1[0];
    var vendor = (0,use_vendor/* default */.Z)();
    var fetcher = (0,hooks/* useFetcher */.wh)();
    var customerComplaintsFF = (0,toggled_esm/* useFeature */.SS)(constants/* flags.CUSTOMER_COMPLAINTS */.id.CUSTOMER_COMPLAINTS);
    var purchaseChannels = customerComplaintsFF === null || customerComplaintsFF === void 0 ? void 0 : (ref = customerComplaintsFF.settings) === null || ref === void 0 ? void 0 : ref.purchaseChannels;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), submitted = ref2[0], setSubmitted = ref2[1];
    if (submitted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            style: {
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(success_state, {})
        });
    }
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var ref, ref1, signedForm, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!variables.fileAttachment) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,utils/* getS3SignedForm */.cC)(variables.fileAttachment, constants/* uploadFolders.CUSTOMER_COMPLAIN_ATTACHMENTS */.A_.CUSTOMER_COMPLAIN_ATTACHMENTS, fetcher)
                        ];
                    case 1:
                        signedForm = _state.sent();
                        return [
                            4,
                            (0,utils/* uploadToS3 */.p7)(signedForm, variables.fileAttachment)
                        ];
                    case 2:
                        _state.sent();
                        variables.attachmentFilename = signedForm === null || signedForm === void 0 ? void 0 : (ref = signedForm.fields) === null || ref === void 0 ? void 0 : ref.filename;
                        variables.attachmentKey = signedForm === null || signedForm === void 0 ? void 0 : (ref1 = signedForm.fields) === null || ref1 === void 0 ? void 0 : ref1.key;
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            createCustomerComplaint({
                                variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
                                    isUnderAge: variables.isUnderage,
                                    code: code,
                                    claimedAmount: parseFloat(variables.claimedAmount)
                                })
                            })
                        ];
                    case 4:
                        _state.sent();
                        setSubmitted(true);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        notifier/* default.error */.Z.error("Ocurri\xf3 un error al crear el reclamo, intente nuevamente.");
                        return [
                            2,
                            (0,handle_submission_errors/* default */.Z)(error)
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var validate = function(formValues) {
        var errors = form_validators/* default.customerComplaint */.ZP.customerComplaint(formValues);
        var privacyPolicyAccepted = form_validators/* default.privacyPolicyAccepted */.ZP.privacyPolicyAccepted({
            vendor: vendor,
            privacyPolicyAccepted: formValues.privacyPolicyAccepted
        }).privacyPolicyAccepted;
        errors.privacyPolicyAccepted = privacyPolicyAccepted;
        if (purchaseChannels) {
            var purchaseChannel = form_validators/* default.purchaseChannel */.ZP.purchaseChannel({
                purchaseChannel: formValues.purchaseChannel
            }).purchaseChannel;
            errors.purchaseChannel = purchaseChannel;
        }
        return errors;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: validate,
        children: function(formProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex rounded bg-neutral-100 p-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mr-auto text-xs",
                                children: formattedNow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-semibold",
                                children: "Reclamo N\xb0\xa0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs",
                                children: code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_complaints_form, (0,_object_spread/* default */.Z)({
                        vendor: vendor,
                        code: code
                    }, formProps))
                ]
            });
        }
    });
};
/* harmony default export */ var customer_complaints = (CustomerComplaintsScreen);

// EXTERNAL MODULE: ./src/utils/get-meta-info.ts
var get_meta_info = __webpack_require__(5024);
// EXTERNAL MODULE: ./src/utils/redirect-to.ts
var redirect_to = __webpack_require__(53337);
;// CONCATENATED MODULE: ./pages/customer-complaints.tsx












var CustomerComplaintsPage = function(props) {
    var metaInfo = props.metaInfo, code = props.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaInfo), {
                title: "Libro de reclamaciones"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_complaints, {
                code: code
            })
        ]
    });
};
CustomerComplaintsPage.standalone = true;
CustomerComplaintsPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var data, code;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!context.hasFlag(constants/* flags.CUSTOMER_COMPLAINTS */.id.CUSTOMER_COMPLAINTS)) {
                        return [
                            2,
                            (0,redirect_to/* default */.Z)("/", context)
                        ];
                    }
                    return [
                        4,
                        context.apolloClient.mutate({
                            mutation: mutations/* createCustomerComplaintCodeMutation */.SE
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    code = data.createCustomerComplaintCode.code;
                    return [
                        2,
                        {
                            metaInfo: (0,get_meta_info/* default */.Z)(context),
                            code: code
                        }
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pages_customer_complaints = (CustomerComplaintsPage);


/***/ }),

/***/ 76741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ InputFile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/filesize.js/lib/index.js
var lib = __webpack_require__(3961);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./src/truck/notifier/index.tsx + 2 modules
var notifier = __webpack_require__(5002);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/components/input-file/elements.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-color: ",
        ";\n  border-radius: 4px;\n  border-style: dashed;\n  border-width: 1px;\n  cursor: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  justify-content: center;\n  padding: ",
        "px ",
        "px;\n\n  * {\n    cursor: inherit;\n  }\n\n  label {\n    ",
        "\n    user-select: none;\n  }\n\n  svg {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: ",
        "px;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-936dcb06-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.compact;
});
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-936dcb06-1"
})(_templateObject1(), function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.disabled ? "not-allowed" : "pointer";
}, function(props) {
    return props.theme.spacing.compact;
}, function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.disabled && "color: ".concat(props.theme.palette.grayscale60, ";\n    ");
}, function(props) {
    return props.disabled && "fill: ".concat(props.theme.palette.grayscale60, ";\n    ");
});
var FirstRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-936dcb06-2"
})(_templateObject2(), function(props) {
    return props.theme.spacing.cozy;
});
var WarningContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-936dcb06-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/input-file/input-file.tsx








function InputFile(props) {
    var onChange = props.onChange, description = props.description, disabled = props.disabled, supportingText = props.supportingText, sizeLimit = props.sizeLimit, accept = props.accept, style = props.style, className = props.className;
    var fileSizeHumanFormat = (0,lib/* default */.Z)(sizeLimit, 0);
    var fileInputRef = react.useRef(null);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var handleClick = function() {
        if (disabled) {
            return;
        }
        fileInputRef.current.click();
    };
    var handleChange = function(event) {
        var files = event.target.files;
        if (!files[0] || files[0].size > sizeLimit) {
            notifier/* default.error */.Z.error("El archivo supera el m\xe1ximo de ".concat(fileSizeHumanFormat), {
                timeout: 5000
            });
            return;
        }
        onChange(event);
        fileInputRef.current.value = null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                disabled: disabled,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        style: {
                            display: "none"
                        },
                        accept: accept,
                        type: "file",
                        ref: fileInputRef,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FirstRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                type: "download",
                                size: "md",
                                color: "primary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                $color: "primary",
                                $textStyle: "h5Bold",
                                children: "Adjuntar archivos"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                        $textStyle: "h6Regular",
                        $color: "grayscale60",
                        children: description
                    })
                ]
            }),
            supportingText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WarningContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        interactive: false,
                        type: "info",
                        color: "grayscale60",
                        size: "sm",
                        style: {
                            marginTop: theme.spacing.compact
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                        as: "span",
                        $textStyle: "h6Regular",
                        $color: "grayscale60",
                        children: supportingText
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/input-file/index.tsx



/***/ }),

/***/ 95920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(67294)):0}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),s=a(6),c=r(s),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.oneOf(["onload","explicit"]),sitekey:u.default.string,theme:u.default.oneOf(["light","dark"]),type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.oneOf(["invisible","compact","normal"]),tabindex:u.default.string,hl:u.default.string,badge:u.default.oneOf(["bottomright","bottomleft","inline"])},f={elementID:"g-recaptcha",className:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha&&"function"==typeof window.grecaptcha.render},y=void 0,b=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||"undefined"==typeof window||(y=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),l(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(y)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"execute",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.execute(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(y))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:this.props.className,"data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(s.Component);t.default=b,b.propTypes=d,b.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,l,s){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,l,s],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,l){l!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(90161); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);